import React, { useState } from "react";
import { SparklesIcon, XMarkIcon } from "@heroicons/react/16/solid";
import { api } from "../../api";
import { Button } from "../tailwind/button";

const ChatGPTFilterSearch = ({
  onFiltersGenerated,
  customFields = {},
  tags = [],
  isLoading = false,
  onLoadingChange,
  recentCampaigns = [],
  activeAutomations = [],
  chatbots = [],
  integrations = {},
}) => {
  const [searchText, setSearchText] = useState("");
  const [isGenerating, setIsGenerating] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const trimmedText = searchText.trim();

    if (!trimmedText || isGenerating) {
      return;
    }

    setIsGenerating(true);
    onLoadingChange?.(true);

    try {
      const result = await api.generateFiltersFromTextWithAI({
        text: trimmedText,
        customFields: customFields,
        tags: tags,
        recentCampaigns: recentCampaigns,
        activeAutomations: activeAutomations,
        chatbots: chatbots,
        integrations: integrations,
      });

      if (result.success) {
        onFiltersGenerated(result.filterGroups);
        setSearchText(""); // Clear the search after successful generation
      } else {
        console.error("Failed to generate filters:", result.error);
        // Could show an error message to user here
      }
    } catch (error) {
      console.error("Error generating filters:", error);
      // Could show an error message to user here
    } finally {
      setIsGenerating(false);
      onLoadingChange?.(false);
    }
  };

  const handleClear = () => {
    setSearchText("");
  };

  const isDisabled = isGenerating || isLoading;

  return (
    <form onSubmit={handleSubmit} className="flex items-center gap-2">
      <div className="relative flex-1 min-w-0">
        <div className="relative">
          <SparklesIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400" />
          <input
            type="text"
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            placeholder="Explain your filters with your own words..."
            className="w-full pl-10 pr-10 py-2 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-1 focus:ring-pink focus:border-transparent disabled:bg-gray-100 disabled:cursor-not-allowed"
            disabled={isDisabled}
          />
          {searchText && (
            <button
              type="button"
              onClick={handleClear}
              className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600"
              disabled={isDisabled}
            >
              <XMarkIcon className="h-4 w-4" />
            </button>
          )}
        </div>
        <div className="absolute top-full left-0 text-xs text-gray-500 mt-1 hidden md:block">
          e.g. "recent optins", "people that did not opened the last campaign"
        </div>
      </div>
      <Button
        type="submit"
        color="secondaryButton"
        disabled={isDisabled || !searchText.trim()}
        className="min-w-[150px] max-h-10 min-h-10"
      >
        <SparklesIcon className="h-4 w-4" />
        Generate filters
      </Button>
    </form>
  );
};

export default ChatGPTFilterSearch;
